<template>
	<div class="d-flex j-center">
		<div>
			<div class="d-flex a-center">
				<div @click="setCurindex(0)" style="width: 150px;height: 28px;border: 2px solid #1E69FF;border-radius: 4px;font-size: 12px;cursor: pointer;"
				class="d-flex j-center a-center" :style="curIndex==0?'background: #1E69FF;':''">
					<img v-if="curIndex==0" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/xzgg.png" />
					<img v-else style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/mrgg.png" />
					<div style="margin-left: 5px;" :style="curIndex==0?'color: #FFFFFF;':'color: #1E69FF;'">商会广告位</div>
				</div>
				<div @click="setCurindex(1)" style="width: 150px;height: 28px;border: 2px solid #1E69FF;border-radius: 4px;font-size: 12px;cursor: pointer;margin-left: 50px;"
				class="d-flex j-center a-center" :style="curIndex==1?'background: #1E69FF;':''">
					<img v-if="curIndex==1" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/xzgg.png" />
					<img v-else style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/mrgg.png" />
					<div style="margin-left: 5px;" :style="curIndex==1?'color: #FFFFFF;':'color: #1E69FF;'">我申请的广告位</div>
				</div>
				<div @click="setCurindex(2)" style="width: 150px;height: 28px;border: 2px solid #1E69FF;border-radius: 4px;font-size: 12px;cursor: pointer;margin-left: 50px;"
				class="d-flex j-center a-center" :style="curIndex==2?'background: #1E69FF;':''">
					<img v-if="curIndex==2" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/xzgg.png" />
					<img v-else style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/mrgg.png" />
					<div style="margin-left: 5px;" :style="curIndex==2?'color: #FFFFFF;':'color: #1E69FF;'">我入驻的广告位</div>
				</div>
				<div class="search">
					<input @submit.native.prevent type="text" v-model="keyword" @input="searchGodos" placeholder="请输入搜索关键字">
					<div class="icon d-flex j-center a-center" style="cursor: pointer;" @click="searchGodos">
						<i class="el-icon-search"></i>
					</div>
				</div>
			</div>
			<div class="content-box">
				<div v-if="curIndex==0" style="font-size:16px;font-weight: 600;margin-bottom: 10px;">我的商会广告</div>
				<div v-if="curIndex==0" class="list-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
					<div style="width: 420px;display: flex;height: 60px;align-items: center;margin-top: 26px;"
					v-for="(item,index) in mine_fcib_ad_list" :key="index">
						<div style="width: 60px;height: 60px;">
							<img style="width: 60px;height: 60px;" :src="item.logo_thumb" />
						</div>
						<div style="margin-left: 15px;flex: 1;display: flex;flex-direction: column;justify-content: space-between;">
							<div style="font-size: 14px;font-weight: 600;">{{item.company_name}}</div>
							<div style="font-size: 12px;color: #666666;">{{item.kf_tel}}</div>
							<div style="font-size: 12px;color: #666666;">{{item.province_name}}{{item.city_name}}{{item.district_name}}{{item.shop_address}}</div>
						</div>
						<div style="margin-left: auto;display: flex;flex-direction: column;justify-content: space-between;height: 60px;">
							<div v-if="item.ad_type == 2" style="font-size: 14px;font-weight: 600;text-align: right;color: #FF2323;">{{item.ad_price}}元/周</div>
							<div v-if="item.ad_type == 1" style="font-size: 14px;font-weight: 600;text-align: right;color: #FF2323;">商会免费广告</div>
							<div  @click="$router.push({path:'banner_detaile',query:{ad_id:item.ad_id,ad_type:item.ad_type}})" style="width: 100px;height: 28px;background: #FFFFFF;border: 2px solid #BBBBBB;border-radius: 4px;
							box-sizing: border-box;font-size: 12px;color: #888888;cursor: pointer;" class="d-flex a-center j-center">
								申请广告位
							</div>
						</div>
					</div>
				</div>
				<div v-if="curIndex==0" style="font-size:16px;font-weight: 600;margin-bottom: 10px;margin-top: 50px;">商会广告位</div>
				<div v-if="curIndex==0" class="list-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
					<div style="width: 420px;display: flex;height: 60px;align-items: center;margin-top: 26px;"
					v-for="(item,index) in fcib_ad_list" :key="index">
						<div style="width: 60px;height: 60px;">
							<img style="width: 60px;height: 60px;" :src="item.logo_thumb" />
						</div>
						<div style="margin-left: 15px;flex: 1;display: flex;flex-direction: column;justify-content: space-between;">
							<div style="font-size: 14px;font-weight: 600;">{{item.company_name}}</div>
							<div style="font-size: 12px;color: #666666;">{{item.kf_tel}}</div>
							<div style="font-size: 12px;color: #666666;">{{item.province_name}}{{item.city_name}}{{item.district_name}}{{item.shop_address}}</div>
						</div>
						<div style="margin-left: auto;display: flex;flex-direction: column;justify-content: space-between;height: 60px;">
							<div style="font-size: 14px;font-weight: 600;text-align: right;color: #FF2323;">{{item.ad_price}}元/周</div>
							<div @click="$router.push({path:'banner_detaile',query:{ad_id:item.ad_id,ad_type:item.ad_type}})" style="width: 100px;height: 28px;background: #FFFFFF;border: 2px solid #BBBBBB;border-radius: 4px;
							box-sizing: border-box;font-size: 12px;color: #888888;cursor: pointer;" class="d-flex a-center j-center">
								申请广告位
							</div>
						</div>
					</div>
				</div>
				<el-table v-else ref="multipleTable" :height="590" :border="false" :data="tableData" tooltip-effect="dark"
					style="font-size: 0.75rem;">
					<el-table-column align="center" prop="rz_shopName" label="广告商会" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" prop="ad_sort" label="广告位置">
						<template slot-scope="scope">
							{{scope.row.ad_sort}}号banner广告位
						</template>
					</el-table-column>
					<el-table-column align="center" prop="price" label="单价">
						<template slot-scope="scope">
							{{scope.row.price}}元/周
						</template>
					</el-table-column>
					<el-table-column align="center" prop="put_time_str"  label="申请开始投放时间" width="150">
					</el-table-column>
					<el-table-column align="center" prop="use_week"  label="广告投放周期">
						<template slot-scope="scope">
							{{scope.row.use_week}}周
						</template>
					</el-table-column>
					<el-table-column align="center" prop="count_price"  label="总价" >
						<template slot-scope="scope">
							<span style="color: #FF2323;">
								{{scope.row.count_price}}元
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sign_status"  label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.sign_status == 0">
								审核中
							</span>
							<span v-if="scope.row.sign_status == 1">
								审核通过
							</span>
							<span v-if="scope.row.sign_status == 2">
								审核未通过
							</span>
							<span v-if="scope.row.sign_status == 3">
								排期中
							</span>
							<span v-if="scope.row.sign_status == 4">
								投放中
							</span>
							<span v-if="scope.row.sign_status == 5">
								已过期
							</span>
							<span v-if="scope.row.sign_status == 6">
								产品已失效
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sign_status" label="操作" >
						<template slot-scope="scope">
							<div v-if="scope.row.sign_status == 0" 
							style="width: 120px;height: 28px;border: 2px solid #BBBBBB;border-radius: 4px;color: #BBBBBB;font-size: 12px;">
								付费
							</div>
							<div @click="$router.push({path:'pay_index',query:{id:scope.row.id}})" v-if="scope.row.sign_status == 1"
							style="width: 120px;height: 28px;border: 2px solid #1E69FF;border-radius: 4px;color: #1E69FF;cursor: pointer;font-size: 12px;">
								付费
							</div>
							<div @click="$router.push({path:'apply_banner_detaile',query:{ad_id:scope.row.id}})" 
							v-if="(scope.row.sign_status == 3||scope.row.sign_status == 4) && scope.row.banner_type == 2"
							style="width: 120px;height: 28px;border: 2px solid #1E69FF;border-radius: 4px;color: #1E69FF;cursor: pointer;font-size: 12px;">
								续费
							</div>
							<div
							v-if="(scope.row.sign_status == 3||scope.row.sign_status == 4) && scope.row.banner_type == 1"
							style="width: 120px;height: 28px;border: 2px solid #BBBBBB;border-radius: 4px;color: #BBBBBB;cursor: pointer;font-size: 12px;">
								不可续费
							</div>
							<div v-if="scope.row.sign_status == 2"
							style="width: 120px;height: 28px;border: 2px solid #1E69FF;border-radius: 4px;color: #1E69FF;cursor: pointer;font-size: 12px;">
								产看原因修改内容
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="d-flex a-center j-center" style="height: 50px;background: #FFFFFF;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10,15,20]" 
					layout="total, sizes, prev, pager, next, jumper" :total="total_records">
				</el-pagination>
			</div>
		</div>
		
	</div>		
</template>

<script>
	export default{
		data(){
			return{
				curIndex:0,
				keyword:'',
				currentPage: 1, //初始页
				pageSize : 10,
				total_records: 0,
				mine_fcib_ad_list:[],
				fcib_ad_list:[],
				tableData:[]
			}
		},
		created() {
			this.getOnsalegoods()
		},
		methods:{
			openDetail(index, row){
				row.editStatus = true
				row.editState = 1
				this.$router.push({path:'banner_detaile',query:{...row,state:1}})
			},
			setCurindex(idnex){
				this.curIndex = idnex
				this.getOnsalegoods()
			},
			searchGodos(){
				this.getOnsalegoods()
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.getOnsalegoods()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()
			},
			getOnsalegoods(){
				let param = {
					act : this.curIndex==0?'ep_banner_ad_list':'ep_banner_ad_sign_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page : this.currentPage,
					size : this.pageSize,
					company_name : this.keyword,
					apply_type: this.curIndex-1
				}
				this.$api.staff_card_list(param).then((res)=>{
					this.fcib_ad_list = []
					this.mine_fcib_ad_list = []
					this.tableData = []
					if(res.code == 0){
						if(this.curIndex == 0){
							this.fcib_ad_list = res.data.fcib_ad_list
							this.mine_fcib_ad_list = res.data.mine_fcib_ad_list
						}else{
							this.tableData = res.data
						}
						this.total_records = parseInt(res.total_records)
					}
					
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.content-box{
		width: 1170px;
		min-height: 760px;
		background: #FFFFFF;
		border-radius: 6px;
		flex-wrap: wrap;
		padding: 30px 60px 30px 30px;
		box-sizing: border-box;
		margin-top: 20px;
	}
	.search {
		width: 16.9rem;
		height: 1.69rem;
		position: relative;
		margin-left: auto;
		input {
			font-size: 0.75rem;
			outline: none;
			border: 2px solid #1E69FF;
			border-radius: 4px;
			padding: 0 1.44rem;
			height: 100%;
			width: 100%;
			box-sizing: border-box;
	
			&::placeholder {
				font-size: .75rem;
			}
		}
	
		.icon {
			background: #1E69FF;
			height: 100%;
			padding: 0 0.38rem;
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			border-radius: 0 4px 4px 0;
	
			i {
				color: #FFFFFF;
			}
		}
	
	
		&::-webkit-input-placeholder {
			color: #BBBBBB;
			font-size: 0.77rem;	
		}
	}
</style>